import { render, staticRenderFns } from "./MultipleCheckboxField.vue?vue&type=template&id=15e59e67&scoped=true"
import script from "./MultipleCheckboxField.vue?vue&type=script&lang=js"
export * from "./MultipleCheckboxField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e59e67",
  null
  
)

export default component.exports